import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 24,
    fontSize: 12,
  },
  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 10,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableColHeader: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#eee',
    padding: 4,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
    textAlign: 'center',
  },
});

export const PdfRegistros = ({ data }) => {
  if (!data || data.length === 0) return null;
  // Definir las columnas a mostrar y sus labels
  // Definir anchos fijos para cada columna (en puntos)
  // Total: 120+80+100+100+120+100 = 620 (A4 útil ~ 620 puntos)
  const columns = [
    { key: 'name', label: 'Nombre', width: 100 },
    { key: 'licensePlate', label: 'Placa', width: 70 },
    { key: 'serie', label: 'Serie', width: 90 },
    { key: 'brand', label: 'Marca', width: 80 },
    { key: 'modelo', label: 'Modelo', width: 90 },
    { key: 'dependencyName', label: 'Dependencia', width: 110 },
    { key: 'location', label: 'Ubicación', width: 90 },
  ];

  // Mapear los datos para extraer los campos requeridos
  const mappedData = data.map(row => ({
    name: row.name || row.Nombre || '',
    licensePlate: row.licensePlate || row.biomedicEquipment?.active || '',
    serie: row.biomedicEquipment?.serie || '',
    brand: row.brand || row.marca || row.biomedicEquipment?.brand || '',
    modelo: row.biomedicEquipment?.modell || '',
    dependencyName: (row.dependency && (row.dependency.name)) || '',
    location: row.location?.name || '',
  }));

  // Dividir los datos en páginas de 16 registros
  const chunkSize = 16;
  const pages = [];
  for (let i = 0; i < mappedData.length; i += chunkSize) {
    pages.push(mappedData.slice(i, i + chunkSize));
  }

  return (
    <Document>
      {pages.map((pageData, pageIndex) => (
        <Page size="A4" style={styles.page} key={pageIndex}>
          <Text style={{ fontSize: 16, marginBottom: 10 }}>Registros de Inventario</Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              {columns.map((col, idx) => (
                <Text key={idx} style={{ ...styles.tableColHeader, width: col.width }}>{col.label}</Text>
              ))}
            </View>
            {pageData.map((row, i) => (
              <View style={styles.tableRow} key={i}>
                {columns.map((col, idx) => {
                  let value = String(row[col.key]);
                  if (col.key === 'serie' && value.length > 10) {
                    value = value.slice(0, 10) + '\n' + value.slice(10);
                  }
                  return (
                    <Text key={idx} style={{ ...styles.tableCol, width: col.width }}>{value}</Text>
                  );
                })}
              </View>
            ))}
          </View>
        </Page>
      ))}
    </Document>
  );
};
